import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectionStrategy,
  HostBinding,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent {
  @Input() label: string = "";
  @Input() disabled: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() error: boolean = false;
  @Input() size: "small" | "medium" | "large" = "medium";
  // Controls whether hover color animations are shown
  @Input() isHoverAnimation: boolean = true;

  @Output() changed = new EventEmitter<boolean>();

  @HostBinding("class.disabled") get isDisabled() {
    return this.disabled;
  }

  @HostBinding("class.error") get hasError() {
    return this.error;
  }

  @Input() checked: boolean = false;

  // private onChange: (value: boolean) => void = () => {};
  // private onTouched: () => void = () => {};

  onChangeInput(e): void {
    if (this.disabled) return;
    // console.log("Checkbox toggle before:", this.checked, e);
    // this.checked = !this.checked;
    this.indeterminate = false;
    // this.onChange(this.checked);
    // this.onTouched();
    this.changed.emit(this.checked);
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }

  // registerOnChange(fn: (value: boolean) => void): void {
  //   this.onChange = fn;
  // }

  // registerOnTouched(fn: () => void): void {
  //   this.onTouched = fn;
  // }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
